module.exports = __webpack_public_path__ + "static/media/university-bg.30b934ad.png";